// Client-side card tokenization for pagar.me v5.
//
// IMPORTANT: this runs in the browser and uses the PUBLIC key only. Raw card
// data goes straight to pagar.me and never touches the Pitch backend — the
// backend only ever receives the single-use token returned here.

const PAGARME_TOKENS_URL = "https://api.pagar.me/core/v5/tokens";

function onlyDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

// Normalizes a 2 or 4 digit year into the 2-digit form pagar.me expects.
function normalizeYear(year) {
  const digits = onlyDigits(year);
  return digits.length === 4 ? digits.slice(2) : digits;
}

/**
 * Tokenizes a credit card. Returns the token id (e.g. "token_xxx").
 * @param {{number:string, holderName:string, expMonth:string|number,
 *          expYear:string|number, cvv:string}} card
 */
export async function tokenizeCard(card) {
  const publicKey = process.env.VUE_APP_PAGARME_PUBLIC_KEY;
  if (!publicKey) {
    throw new Error("Chave pública de pagamento não configurada.");
  }

  const response = await fetch(
    `${PAGARME_TOKENS_URL}?appId=${encodeURIComponent(publicKey)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: "card",
        card: {
          number: onlyDigits(card.number),
          holder_name: card.holderName,
          exp_month: Number(onlyDigits(card.expMonth)),
          exp_year: Number(normalizeYear(card.expYear)),
          cvv: onlyDigits(card.cvv),
        },
      }),
    }
  );

  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.id) {
    const message =
      (data && data.message) || "Não foi possível validar o cartão.";
    throw new Error(message);
  }

  return data.id;
}
